import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import './portal.css';
import apiService from 'apiService';
import { Carousel } from 'react-bootstrap';

const Portal = () => {
  return (
    <>
      <Navbar />
    </>
  );
};

const Navbar = () => {
  const [isOnHover, setIsOnHover] = useState('');
  const history = useHistory();
  const [profil, setprofil] = useState('');

  const getProfil = async () => {
    const res = await apiService.get('/standalone/profiles')
    if (res.code === 200) {
      setprofil(res.data)
    }
  }
  useEffect(() => {
    getProfil()
  }, [1])
  return (
    <div
      className='main-content'
    >
      <Carousel
        style={{ height: "100px" }}
        interval={4000}
      >

        {profil?.galleries?.map((dat, key) => (
          <Carousel.Item>
            <img
              className="d-block w-100"
              src={dat.name}
              alt="slide"
              style={{ height: "500px" }}
            />
            {/* <Carousel.Caption>
            <h3>First slide label</h3>
            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
          </Carousel.Caption> */}
          </Carousel.Item>
        ))}
        {/* <Carousel.Item>
          <img
            className="d-block w-100"
            src="http://110.76.148.125:8000/uploads/gunungkidul (1).jpeg"
            alt="Second slide"
            style={{ height: "500px" }}
          />


        </Carousel.Item> */}
        {/* <Carousel.Item>
          <img
            className="d-block w-100"
            src="http://110.76.148.125:8000/uploads/gunungkidul (1).jpeg"
            alt="Third slide"
            style={{ height: "500px" }}
          />


        </Carousel.Item> */}
      </Carousel>
      <div className='container-fluid mt--6'>
        <div className='container'>
          <div className='row align-item-center text-left'>
            <div className='col-lg-5 col-10 mt-2 mt-lg-5'>
              <h1 className='display-2 text-success'>
                <span>
                  <small className='text-primary'>Selamat Datang di</small>
                </span>
                {profil?.name}
              </h1>
              <p className='text-primary pb-4 text-white'>
                Akses Layanan kesehatan Perijinan secara mudah dan cepat.
              </p>
            </div>
            {/* <div className='col-lg-7 col-10 mt-2 mt-lg-5'>
              <img
                src='https://cdn.pixabay.com/photo/2013/05/25/21/34/mount-merapi-113620_1280.jpg'
                className='img-fluid rounded'
              />
            </div> */}
          </div>
        </div>
      </div>
      <div
        className='container-fluid bg-white mt-6'>
        <div className='container py-4'>
          <div className='row'>
            {/* <div className='col-md-3'>
              <div className='card menu' onClick={() => history.push('/emergency')}>
                <div className='card-body '>
                  <div className='icon icon-lg icon-shape icon-shape-danger rounded-circle'>
                    <i className='fa fa-ambulance' />
                  </div>
                  <h2 className='text-danger mt-2'>Emergency</h2>
                  <p className='description'>
                    Lapor dan akses data jejaring kesehatan untuk keperluan daruratmu
                  </p>
                </div>
              </div>
            </div> */}
            {/* <div className='col-md-3'>
              <div className='card menu' onClick={() => history.push('/service')}>
                <div className='card-body'>
                  <div className='icon icon-lg icon-shape icon-shape-info rounded-circle'>
                    <i className='fa fa-user' />
                  </div>
                  <h2 className='text-info mt-2'>Layanan Publik</h2>
                  <p className='description'>
                    Nikmati Pendaftaran Pelayanan Kesehatan dengan mudah dan cepat secara online
                  </p>
                </div>
              </div>
            </div> */}
            <div className='col-md-3'>
              <div className='card menu' onClick={() => history.push('/service/pirt/daftar-penyuluhan')}>
                <div className='card-body'>
                  <div className='icon icon-lg icon-shape icon-shape-primary rounded-circle'>
                    <i className='fa fa-newspaper' />
                  </div>
                  <h2 className='text-primary mt-2'>Penyuluhan PIRT</h2>
                  <p className='description'>
                    Daftar Penyuluhan PIRT
                  </p>
                </div>
              </div>
            </div>
            {/* <div className='col-md-3'>
              <div className='card menu' onClick={() => history.push('/data')}>
                <div className='card-body'>
                  <div className='icon icon-lg icon-shape icon-shape-success rounded-circle'>
                    <i className='fa fa-database' />
                  </div>
                  <h2 className='text-success mt-2'>Data</h2>
                  <p className='description '>
                    Cari dan temukan data kesehatan yang kamu inginkan secara cepat dan akurat
                  </p>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Portal;
